import React, { useEffect, useState } from 'react';
interface ShowVideoInterface {
    showModal: any
    handleClose: any
}
export const ShowVideo: React.FC<ShowVideoInterface> = ({ showModal, handleClose }) => {
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (!showModal || !isLargeScreen) return null;

    return (
        <div onClick={handleClose} className="flex fixed inset-0 bg-black bg-opacity-75 justify-center items-center z-40">
            <div className="relative w-full max-w-3xl">
                <button
                    onClick={handleClose}
                    className="absolute top-2 right-2 text-white text-3xl font-bold z-50 translate-x-10 -translate-y-10"
                >
                    &times;
                </button>
                <div className="relative w-full aspect-video mx-auto">
                <iframe
                    title='por que invertir en lokal colombia'
                    className="absolute top-0 left-0 w-full h-full rounded-3xl"
                    src="https://www.youtube.com/embed/tuGviQOfMQU?autoplay=1&mute=0"
             
              allow="autoplay; encrypted-media"
              allowFullScreen
              loading="lazy"
                ></iframe>
                </div>
            </div>
        </div>
    );
};
